/* ---------- 6. venue map link ---------- */

import { $, $$, EXTERNAL, enc, setAttrs } from '../lib/dom';

const MAP_PARTS = ['line1', 'city', 'state', 'zip'];

/** [data-map-link] inside .map_fpo → Google Maps search for the [data-map-*] lines; no address → link hidden. */
export const mapLinks = () =>
  $$('[data-map-link]').forEach((link) => {
    const wrap = link.closest('.map_fpo');
    if (!wrap) return;
    const address = MAP_PARTS.map((part) => $(`[data-map-${part}]`, wrap)?.textContent?.trim())
      .filter(Boolean)
      .join(', ');
    if (!address) {
      link.style.display = 'none';
      return;
    }
    setAttrs(link, { ...EXTERNAL, href: `https://www.google.com/maps/search/?api=1&query=${enc(address)}` });
  });
